import React from 'react'

export type TextareaProps = {
  name?: string
  id?: string
  placeholder?: string
  reference?: React.Ref<HTMLTextAreaElement>
  error?: boolean
  label: string
  message?: string
  helpText?: string
  disabled?: boolean
  row?: number
  rows?: number
  defaultValue?: string
  maxLength?: number
  testId?: string
  describedById?: string
}

export const Textarea = (props: TextareaProps) => {
  const {
    name,
    id,
    placeholder,
    reference,
    error,
    label,
    message,
    helpText,
    disabled,
    row,
    rows,
    defaultValue,
    maxLength,
    testId,
    describedById
  } = props

  const isError = Boolean(error)
  const hasErrorMessage = isError && Boolean(message)
  const hasHelpText = Boolean(helpText)
  const helpListId = describedById || (id ? `${id}-error-help` : undefined)
  const shouldDescribeTextarea = hasErrorMessage || hasHelpText
  const resolvedRows = rows ?? row

  return (
    <div className="Textarea-group">
      {label && (
        <label
          className="Input-label"
          htmlFor={id}
          data-testid={testId ? `${testId}-label` : undefined}
        >
          {label}
        </label>
      )}
      <textarea
        className={['Textarea', isError ? 'Textarea--error' : '']
          .filter(Boolean)
          .join(' ')}
        id={id}
        name={name}
        rows={resolvedRows}
        disabled={disabled}
        aria-describedby={shouldDescribeTextarea ? helpListId : undefined}
        placeholder={placeholder}
        ref={reference}
        defaultValue={defaultValue}
        maxLength={maxLength}
        data-testid={testId ? `${testId}-textarea` : undefined}
      />
      {(hasErrorMessage || hasHelpText) && (
        <ul id={helpListId}>
          {hasErrorMessage && (
            <li
              className="Form-help Form-help--error"
              data-qa={'TextareaError-' + id}
              data-testid={testId ? `${testId}-message` : undefined}
            >
              <span
                data-testid={testId ? `${testId}-warning` : undefined}
                aria-hidden="true"
              >
                warning
              </span>
              <span className="u-hiddenVisually">Error,</span>
              <span>{message}</span>
            </li>
          )}
          {hasHelpText && <li className="Form-help">{helpText}</li>}
        </ul>
      )}
    </div>
  )
}
